import React from 'react';
import PropTypes from 'prop-types';

import Popup from '../../Popup';
import styles from './genericPopup.scss';

const CPP_VARIANT = 'cpp';

const GenericPopup = ({
    imageSource,
    title,
    subtitle,
    description,
    buttonText,
    onRequestClose,
    onButtonClick,
    variant,
    'data-testid': dataTestId,
}) => {
    const handleOnRequestClose = () => {
        onRequestClose();
    };

    const handleOnActionButtonClicked = () => {
        onButtonClick();
    };

    const isCpp = variant === CPP_VARIANT;

    return (
        <Popup
            className="popup-md"
            popUpClassName={isCpp ? 'cpp-popup-card' : ''}
            onCloseClick={handleOnRequestClose}
            config={{
                fullScreen: false,
                noPadding: false,
                gradient: !isCpp,
                scrollable: false,
            }}
        >
            <div className={`${isCpp ? styles.containerCpp : styles.container} container`} data-testid={dataTestId}>
                <div>
                    {imageSource && (
                        <div className="mb10">
                            <img className={styles.image} src={imageSource} data-testid={dataTestId ? `${dataTestId}.image` : undefined} />
                        </div>
                    )}
                    <div className={isCpp ? styles.titleCpp : styles.title} data-testid={dataTestId ? `${dataTestId}.title` : undefined}>
                        {title}
                    </div>
                    <div className={isCpp ? styles.bodyCpp : 'mt16 mb16'} data-testid={dataTestId ? `${dataTestId}.subtitle` : undefined}>
                        {subtitle}
                    </div>
                    {!!description && (
                        <div className={isCpp ? styles.bodyCpp : 'mt16 mb16'} data-testid={dataTestId ? `${dataTestId}.description` : undefined}>
                            {description}
                        </div>
                    )}
                    <div className={isCpp ? styles.buttonRowCpp : undefined}>
                        <button
                            type="button"
                            onClick={handleOnActionButtonClicked}
                            className={isCpp ? styles.buttonCpp : 'btn btn-primary btn-xl text-uppercase'}
                            data-testid={dataTestId ? `${dataTestId}.action-btn` : undefined}
                        >
                            {buttonText}
                        </button>
                    </div>
                </div>
            </div>
        </Popup>
    );
};

GenericPopup.propTypes = {
    imageSource: PropTypes.string,
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    buttonText: PropTypes.string.isRequired,
    onRequestClose: PropTypes.func.isRequired,
    variant: PropTypes.oneOf([CPP_VARIANT]),
    'data-testid': PropTypes.string,
};

GenericPopup.defaultProps = {
    imageSource: null,
    subtitle: null,
    variant: null,
    'data-testid': null,
};

export default GenericPopup;
